import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

/* NgRx */
import { StoreModule } from '@ngrx/store';
import { reducer } from './state/file.reducer';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EffectsModule } from '@ngrx/effects';
import { FileEffects } from './state/file.effects';

// Módulo con elementos compartidos (pipes, etc.).
import { SharingModule } from '../sharingModule/sharingModule.module';

// Importar módulo para paginación de tablas.
import {NgxPaginationModule} from 'ngx-pagination';

import { FileShellComponent } from './containers/file-shell/file-shell.component';
import { FileComponent } from './components/file-list/file-list.component';
import { FileEditShellComponent } from './containers/file-edit-shell/file-edit-shell.component';
import { FileEditComponent } from './components/file-edit/file-edit.component';

// Módulo para la ordenación de tablas por columnas.
import { SortableColumnModule } from '../sortableColumn/sortableColumn.module';

// Para importar carrusel.
// import { IvyCarouselModule } from 'angular-responsive-carousel';


@NgModule({
  declarations: [
    FileShellComponent,
    FileComponent,
    FileEditShellComponent,
    FileEditComponent
  ],
  imports: [
    SharingModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    StoreModule.forFeature('files', reducer),
    EffectsModule.forFeature([FileEffects]),
    SortableColumnModule,
    NgxPaginationModule
    // IvyCarouselModule
  ],
  exports: [
    FileEditComponent,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SortableColumnModule,
    NgxPaginationModule
    // IvyCarouselModule
  ]
})
export class FileModule {
  constructor(
  ) {}
}
